import type { AppliedDepositAnomaly } from '../services/appliedDeposit';
import type { FirstCollectionAnomaly } from '../services/firstCollectionDate';

// Total Records: a new anomaly code without a hint is a compile error, not a wrong warning.
const ELEMIS_SHAPE_HINT =
    'The elemis period-0 deposit row may have changed shape — see ' +
    'docs/integrations/elemis-payment-schedule-contract.md section 8 B6.';

export const ANOMALY_HINT: Record<AppliedDepositAnomaly, string> = {
    'anchor-mismatch': `Failed closed to prose, no figure shown. ${ELEMIS_SHAPE_HINT}`,
    'row-zero-implausible': `Failed closed to prose, no figure shown. ${ELEMIS_SHAPE_HINT}`,
    'entered-amount-disagrees': `The ENTERED figure is still shown and is authoritative; row 1 merely disagrees with it. ${ELEMIS_SHAPE_HINT}`,
    'entered-amount-implausible':
        'Failed closed to prose, no figure shown. The confirmed selection carries a ' +
        'params.depositAmount that is not a usable integer minor-unit figure — the ' +
        'persisted selection is corrupt and the elemis response is not implicated. ' +
        'params is stored as an opaque, unvalidated document (StoreQuoteRequest rules ' +
        'payment_selection.params as array only, with no sub-rules).',
};

// Unlike the others, anchor-unusable points at the persisted selection, not at elemis.
export const FIRST_COLLECTION_ANOMALY_HINT: Record<FirstCollectionAnomaly, string> = {
    'anchor-unusable':
        'Failed closed to prose, no date shown. The persisted schedule-anchor date is not a ' +
        'valid calendar date — the persisted selection is corrupt and elemis is not implicated.',
    'anchor-mismatch': `Failed closed to prose, no date shown. ${ELEMIS_SHAPE_HINT}`,
    'no-deposit-row-on-anchor': `Failed closed to prose, no date shown. ${ELEMIS_SHAPE_HINT}`,
    'row-date-implausible': `Failed closed to prose, no date shown. ${ELEMIS_SHAPE_HINT}`,
};
